import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
export var forgetPasswordRoute = [{
  path: "forget-password",
  name: "forget-password",
  component: function component() {
    return import("./forget-password.vue");
  }
}];